import React from 'react'
import { Route, Routes } from 'react-router-dom'
import PrivateRoute7  from '../../app/routes/PrivateRoute7'

import EditRegions from './EditRegions'
import ListRegions from './ListRegions'
import NewRegions from './NewRegions'

const AdminRegionsRoutes = () => {
  return (
    <Routes>
        <Route path="/" element={<PrivateRoute7><ListRegions /></PrivateRoute7>} />
        <Route path="edit-region" element={<PrivateRoute7><EditRegions /></PrivateRoute7>} />
        <Route path="new-region" element={<PrivateRoute7><NewRegions /></PrivateRoute7>} />
    </Routes>
  )
}

export default AdminRegionsRoutes